/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuestionsQueryVariables = Types.Exact<{
  type?: Types.InputMaybe<Types.QuestionType>;
}>;

export type QuestionsQuery = {
  __typename?: 'Query';
  questions: Array<{
    __typename?: 'Question';
    _id: string;
    title: string;
    description?: string | null;
    type: Types.QuestionType;
    inputMethod: Types.InputMethod;
    minValue?: number | null;
    maxValue?: number | null;
    minLabel?: string | null;
    maxLabel?: string | null;
    dropdownOptions?: Array<{ __typename?: 'DropdownOption'; option: string }> | null;
  }>;
};

export const QuestionsDocument = gql`
  query questions($type: QuestionType) {
    questions(type: $type) {
      _id
      title
      description
      type
      inputMethod
      dropdownOptions {
        option
      }
      minValue
      maxValue
      minLabel
      maxLabel
    }
  }
`;

/**
 * __useQuestionsQuery__
 *
 * To run a query within a React component, call `useQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
}
export function useQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
}
export type QuestionsQueryHookResult = ReturnType<typeof useQuestionsQuery>;
export type QuestionsLazyQueryHookResult = ReturnType<typeof useQuestionsLazyQuery>;
export type QuestionsQueryResult = Apollo.QueryResult<QuestionsQuery, QuestionsQueryVariables>;
